import $ from './lib/jquery/jquery.js';
import './lib/jquery/jquery.touchSwipe.js';
import * as DateUtils from './lib/DateUtils.ts';
import * as TimezoneUtils from './lib/TimezoneUtils.ts';

window.$=$; //put undefined to seek missing dependancies

document.addEventListener('touchstart',function(){
  document.body.classList.add('hastouchedscreen');
}, {passive: true, once:true});

function getStackLine(){
  return new Error().stack.split(/\r?\n|\r/g)[3].trim()
}
Object.assign(HTMLElement.prototype,{
  metaId(){
    var metaId = this.getAttribute('data-fw-meta-id');
    if(metaId!==null) return metaId;
    if(this.parentElement) return this.parentElement.metaId()
  },
  metaIdNode(){
    var metaId = this.getAttribute('data-fw-meta-id');
    if(metaId!==null) return this;
    if(this.parentElement) return this.parentElement.metaIdNode()
  },
  attr(name){
    console.log(`Use of .attr("${name}") on HTMLElement, replace with .getAttribute("${name}") on ${getStackLine()}`)
    return this.getAttribute(name);
  },
  parent(){
    console.log(`Use of .parent() on HTMLElement, replace with .parentElement on ${getStackLine()}`)
    return this.parentElement;
  },
  parents(selector){
    if(this.parentElement.matches(selector)){
      return this.parentElement
    }
    if(this.parentElement){
      return this.parentElement.parents(selector)
    }
  }
})

$.fn.metaIdNode = function(){
  return this.closest('[data-fw-meta-id]');
}
$.fn.metaId = function(){
  return this.metaIdNode().attr('data-fw-meta-id');
}
$.fn.dateValue = function(date){
  if(arguments.length>0){
    if(!date){
      this.val('');
    }else if(this.attr('type')==='time'){
      this.val(DateUtils.forInputTime(date))
    }else if(this.attr('type')==='date'){
      this.val(DateUtils.forInputDate(date))
    }else if(this.attr('type')==='datetime-local'){
      if(this.attr('timezone')){
        date = TimezoneUtils.toZone(date,this.attr('timezone'))
      }
      this.val(DateUtils.forInputDateTimeLocal(date))
    }else{
      this.val(date.toISOString());
    }
    return this;
  }else{
    if(!this.val()){
      return null; 
    }
    if(this.attr('type')==='date'){
      try{
        var hour = this.attr('data-time');
        if(hour){
          return new Date(this.val()+'T'+hour);
        }else{
          return new Date(this.val()+'T00:00:00Z');
        }  
      }catch(e){
        //case of old safari date might look like 05/19/2023
        //we do nothing and pray that the following new Date() does something good
        console.log(e);
      }
      
    }else if(this.attr('type')==='time'){
      return new Date(new Date().toISOString().substring(0,11)+this.val())
    }

    if(this.attr('timezone')){
      return TimezoneUtils.fromZone(new Date(this.val()),this.attr('timezone'))
    }
    return new Date(this.val())
  }
}
$.fn.localDateValue = function(){
  if(arguments.length>0){
    throw new Error('Cannot set data here');
  }else{
    if(!this.val()){
      return null; 
    }
    if(this.attr('type')==='date'){
      try{
        var hour = this.attr('data-time');
        if(hour){
          return new Date(this.val()+'T'+hour);
        }else{
          return new Date(this.val()+'T00:00:00');
        }  
      }catch(e){
        //case of old safari date might look like 05/19/2023
        //we do nothing and pray that the following new Date() does something good
        console.log(e);
      }
      
    }else if(this.attr('type')==='time'){
      return new Date(new Date().toISOString().substring(0,11)+this.val())
    }
    if(this.attr('timezone')){
      return TimezoneUtils.fromZone(new Date(this.val()),this.attr('timezone'))
    }
    return new Date(this.val())
  }
}

$.fn.amountValue = function(amount){
  var 
    currencyCode = this.attr('data-currency-code'),
    displayCurrency = this.attr('data-currency-display')!=='false',
    lang = $('html').attr('lang'),
    formatter = new Intl.NumberFormat(lang, {
      style: 'currency',
      currency: currencyCode
    }),
    formatterPart = formatter.formatToParts(1000),
    decimal = formatterPart.find(part=>part.type==='decimal').value,
    isLenient = formatterPart.filter(part=>part.value==='.' || part.value===',').length<2,
    verifyAmount = function(amount){
      if(isNaN(amount)) return 0; //reset to original value
      if(amount>9999999.99) amount = 9999999.99; //if too big we limit
      if(amount<0) amount = 0;
      return amount;
    },
    parse = function(stringAmount){
      //first cleaning
      stringAmount = stringAmount.replace(/[^0123456798.,]/g,'')
      //in french the decimal separator is , but user use . which is not a separator
      if(isLenient){
        stringAmount = stringAmount.replaceAll(',','.');
      }else if(decimal===','){
        stringAmount = stringAmount.replaceAll('.','').replaceAll(',','.');
      }else{
        stringAmount = stringAmount.replaceAll(',','');
      }
      
      //we keep only the last dot
      while(stringAmount.indexOf('.')!==stringAmount.lastIndexOf('.')){
        stringAmount = stringAmount.substring(0,stringAmount.indexOf('.'))+stringAmount.substring(stringAmount.indexOf('.')+1)
      }
      return verifyAmount(parseFloat(stringAmount));
    },
    value = displayCurrency?formatter.format(amount):formatter.format(amount).replace(/[^0123456798., ]/g,'');
  if(arguments.length>0){
    if(typeof amount !== 'number') throw new Error(amount+' is not a number');
    return this.val(value)
  }else{
    return parse(this.val())
  }
}
$(document).on("keyup","input[type=number]",function(){
  if(this.max !==undefined) this.value = Math.min(this.value,this.max)
  if(this.min !==undefined) this.value = Math.max(this.value,this.min)
  
})
export default $;
